var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.157 7.587-.244.255.159.316c1.528 3.036 3.729 5.417 6.76 6.973l.298.153.255-.218 2.094-1.791.016-.014.015-.015a.527.527 0 0 1 .537-.132c1.206.403 2.502.62 3.84.62.292 0 .532.235.532.543v3.653c0 .308-.24.543-.532.543C8.476 18.473.84 10.761.84 1.233c0-.306.244-.543.532-.543h3.613c.292 0 .532.236.532.544 0 1.35.215 2.66.612 3.878a.555.555 0 0 1-.132.555l-.005.005-1.834 1.915Z"
  })));
};
export default SvgPhone;